import logo from './logo.svg';
import './App.css';
import React, { useState,useReducer,useEffect } from 'react';
import router from './router';
import Amplify from 'aws-amplify';
import awsConfig from './aws-exports';
import ReactGA from 'react-ga';
import { useDispatch, useSelector } from 'react-redux';
import Loader from "./app/components/Loader";
import { GoogleOAuthProvider } from '@react-oauth/google';
export const UserContext = React.createContext();



Amplify.configure(awsConfig);

const initialState = {
  underAge: null,
  aboveAge: null
}

const globalReducer = (state, action) => {
  switch (action.type) {
    case 'updateUnderAge':
            return {
                ...state, 
                underAge : action.payload
            }
    case 'updateAboveAge':
    return {
        ...state, 
        aboveAge : action.payload
    }
    case 'userAccessRole':
    return {
        ...state, 
        accessRole : action.payload
    }
    case 'reset':
            return initialState
        default:
            return state
    }
}

function App() {
  const [globalState, globalDispatch] = useReducer(globalReducer, initialState);
  const loader = useSelector(state => state.loaderState.loading);
  const dispatch = useDispatch();
  useEffect(()=>{

  },[])
  return (
   <>
     <UserContext.Provider 
      value={
        {
          state: globalState,
          dispatch: globalDispatch
        }
      }
      >
          <Loader visible={loader} />
          <GoogleOAuthProvider clientId="512254333973-ms4l9tmop2ib85jhblvubg8e81ikcq78.apps.googleusercontent.com">
          { router }
          </GoogleOAuthProvider>
        
      </UserContext.Provider>
   </>
  );
}

export default App;
